import { useEffect, useRef } from 'react';

import { AnimationConfigWithData, AnimationConfigWithPath, AnimationItem } from 'lottie-web';

const animations = {
  'journeys-logo': () => import('./animations/journeys-logo-lottie.json'),
};

export type LottieAnimationProps = Omit<
  AnimationConfigWithPath | AnimationConfigWithData,
  'container'
> & {
  animation: keyof typeof animations;
  delay?: number;
};

export const LottieAnimation = ({ animation, delay = 0, ...rest }: LottieAnimationProps) => {
  const animationContainer = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let lottieAnimation: undefined | AnimationItem;

    const load = async () => {
      const lottieModule = await import('lottie-web');
      const animationDataModule = await animations[animation]();
      const lottie = lottieModule.default ?? lottieModule;
      const animationData = animationDataModule.default ?? animationDataModule;

      lottieAnimation = lottie.loadAnimation({
        container: animationContainer.current!,
        animationData,
        autoplay: delay === 0,
        loop: true,
        ...rest,
      });

      if (delay > 0) {
        setTimeout(() => {
          lottieAnimation?.play();
        }, delay);
      }
    };

    load();

    return () => {
      lottieAnimation?.destroy();
    };
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div ref={animationContainer} />;
};
